<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ item }} -->
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="mr-1"></i>
        {{ item.locator }}
      </b-card-header>
      <b-card-body class="py-0">
        <div>
          <b-row class="px-0 mt-0">
            <b-button-group class="ml-3">
              <b-row no-gutters>
                <b-col cols="auto">
                  <b-button
                    squared
                    size="sm"
                    :variant="toolbar_variant"
                    @click="changeview('Travellers')"
                  >
                    <i class="fa fa-suitcase pr-3"></i>Travellers
                  </b-button></b-col
                >
                <b-col cols="auto">
                  <b-button
                    squared
                    size="sm"
                    :variant="toolbar_variant"
                    @click="changeview('Segments')"
                  >
                    <i class="fa fa-globe pr-3"></i>Segments
                  </b-button></b-col
                >
                <b-col cols="auto">
                  <b-button
                    squared
                    size="sm"
                    :variant="toolbar_variant"
                    @click="changeview('Tickets')"
                  >
                    <i class="fa fa-ticket pr-3"></i>Tickets
                  </b-button></b-col
                >

                <b-col cols="auto">
                  <b-button
                    squared
                    size="sm"
                    :variant="toolbar_variant"
                    @click="changeview('EMDs')"
                  >
                    <i class="fa fa-exchange pr-3"></i>EMDs
                  </b-button></b-col
                >
                <b-col cols="auto">
                  <b-button
                    squared
                    size="sm"
                    :variant="toolbar_variant"
                    @click="changeview('Requests')"
                  >
                    <i class="fa fa-check-square pr-3"></i>Requests
                  </b-button></b-col
                >
                <b-col cols="auto">
                  <b-button
                    squared
                    size="sm"
                    :variant="toolbar_variant"
                    @click="changeview('Remarks')"
                  >
                    <i class="fa fa-comment pr-3"></i>Remarks
                  </b-button></b-col
                >
              </b-row>
            </b-button-group>
          </b-row>
        </div>
        <div>
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div class="availtable datatable nested">
              <b-table
                :dark="$store.state.darkMode"
                ref="btable"
                sticky-header="350px"
                striped
                hover
                small
                caption-bottom
                show-empty
                :busy="busy"
                :items="items"
                :fields="options['fields_' + active]"
                :filter="find"
                @row-clicked="rowClicked"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)>
                  <i :class="options.icon" class="text-primary"></i>
                </template>
                <template v-slot:cell(Name)="slot">
                  <!-- Name {
                      Surname
                      Title
                      FirstName
                    } -->
                  {{ slot.item.Name.Title }}
                  {{ slot.item.Name.FirstName }}
                  {{ slot.item.Name.Surname }}
                </template>
                <template v-slot:cell(AccountingDataSummary)="slot">
                  <span id="TotalTaxCharged" title="TotalTaxCharged"
                    >{{ slot.item.AccountingDataSummary.TotalTaxCharged }}
                  </span>
                  <span id="TotalFareCharged" title="TotalFareCharged"
                    >{{ slot.item.AccountingDataSummary.TotalFareCharged }}
                  </span>
                  <span id="IsExchange" title="IsExchange"
                    >{{ slot.item.AccountingDataSummary.IsExchange }}
                  </span>
                  <span id="UnableToRetrieve" title="UnableToRetrieve"
                    >{{ slot.item.AccountingDataSummary.UnableToRetrieve }}
                  </span>
                  <!-- <b-tooltip target="TotalTaxCharged" triggers="hover"
                    >NL Post</b-tooltip
                  > -->
                </template>
                <template v-slot:cell(TravellerReferences)="slot">
                  <span id="PaxProfileID" title="PaxProfileID"
                    >{{ slot.item.TravellerReferences.PaxProfileID }}
                  </span>
                </template>
                <template v-slot:cell(BookingClass)="slot">
                  <span id="ClassCode" title="ClassCode"
                    >{{ slot.item.BookingClass.ClassCode }}
                  </span>
                  <span id="ClassName" title="ClassName"
                    >{{ slot.item.BookingClass.ClassName }}
                  </span>
                  <span
                    id="Cabin"
                    title="Cabin"
                    v-if="
                      slot.item.BookingClass.ClassName !=
                      slot.item.BookingClass.Cabin
                    "
                  >
                    {{ slot.item.BookingClass.Cabin }}
                  </span>
                </template>
                <template v-slot:cell(Seats)="slot"> ...</template>
                <template v-slot:cell(Meals)="slot"> ...</template>
                <template v-slot:cell(Requests)="slot"> ...</template>
                <template v-slot:cell(Coupons)="slot"> ...</template>
                <template v-slot:cell(Traveller)="slot"> ...</template>
                <template v-slot:cell(FareDetails)="slot"> ...</template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        $helpers.badgeField(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in $helpers.actionsValid(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="table_action(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="action.icon"
                                  class="text-primary"
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in $helpers.actionsValid(row.item, options)"
                      :key="action.key"
                      @click.stop="table_action(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="action.icon" class="text-primary"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details="row">
                  <b-card>
                    <component
                      :is="options.component.name"
                      :search="search"
                      @discard="discard(row)"
                    ></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? dispatcher(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
          <b-row class="excelsheetbuttons px-1 mb-3">
            <b-col>
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin"></i>
                <span class="ml-1">Updating ...</span>
              </div>
              <span v-if="!busy">Found {{ items.length }} rows</span>
            </b-col>

            <b-col class="text-right">
              <b-link
                id="pnr-excel"
                class="mt-1 excel"
                @click="$helpers.outputExcel({ items })"
                title="Send to excel"
              >
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="pnr-excel" triggers="hover"
                >Grid to excel</b-tooltip
              >
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="my-2">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span class="text-primary">{{ message }}</span>
            </div>
          </b-col>
          <b-col cols="8" class="text-right">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "PNRData",
  data() {
    return {
      toolbar_variant: "outline-primary",
      busy: false,
      message: "",
      find: null,
      id: null,
      items: [],
      item: {},
      active: "Travellers",
      options: {
        title: "PNR Data",
        icon: "fa fa-sitemap text-primary",
      },
    };
  },
  methods: {
    async load() {
      this.busy = true;
      let variables = {
        id: this.idselected,
        dateformat: "DD/MM/YYYY HH:MM:SS",
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query pnrs($id: String, $dateformat: String) {
              pnrs(id: $id, dateformat:$dateformat) {
                id
                dateissued
                locator
                docdate
                docnumber
                fileref
                source
                bookingtype
                creationdate
                creationagentid
                Travellers {
                  TravellerNumber
                  SabreNameNumber
                  Name {
                    Title
                    FirstName
                    Surname
                  }
                  PaxType
                  TravellerReferences {
                    PaxProfileID
                  }
                }
                Segments {
                  SegmentNumber
                  FlightFlown
                  MarketingCarrier
                  OperatingCarrier
                  StartDate
                  StartTime
                  StartCity
                  StartTerminal
                  EndDate
                  EndTime
                  EndCity
                  EndTerminal
                  FlightNumber
                  NStopOvers
                  Equipment
                  BaggageAllowance
                  Distance
                  Duration
                  Status
                  VendorLocator
                  BookingClass {
                    ClassCode
                    ClassName
                    Cabin
                  }
                  Seats {
                    TravellerNumber
                    SegmentNumber
                    SabreNameNumber
                    CoachNumber
                    SeatData
                    Status
                  }
                  Meals {
                    MealCode
                    Status
                  }
                  Requests {
                    TravellerNumber
                    SegmentNumber
                    SabreNameNumber
                    RequestType
                    RequestCode
                    RequestDetails
                  }
                }
                Tickets {
                  TravelDate
                  TicketIssueDate
                  TicketIssueAgentID
                  TicketBranch
                  AssociatedRecordLocator
                  FirstTicketNumber
                  NConj
                  AccountingDataSummary {
                    IsExchange
                    UnableToRetrieve
                    TotalTaxCharged
                    TotalFareCharged
                  }
                  IATANumber
                  TicketType
                  Eticket
                  PlatingCarrier
                  PlatingCarrierTicketingCode
                  CustomerBillingNumber
                  FareDetails {
                    FareType
                    PricingType
                    BaseFare {
                      _
                      Currency
                      Text
                    }
                    EquivalentFare {
                      _
                      Currency
                    }
                    Taxes {
                      Total
                      Currency
                      Tax {
                        _
                        CodeOrDescription
                        Exempt
                      }
                    }
                    TotalFare {
                      _
                      Currency
                      Text
                    }
                    FareCalculation {
                      _
                      Type
                      CalculationMode
                    }
                    FareEndorsements {
                      FareEndorsement
                    }
                    TourCode
                    PaymentDetails {
                      PaymentType
                      PaymentText
                      PaymentAmount
                    }
                  }
                  Coupons {
                    CouponNumber
                    CodedStatus
                    StatusCode
                    FareBasisCode
                    AirSegment {
                      SegmentNumber
                      FlightFlown
                      Source
                      MarketingCarrier
                      OperatingCarrier
                      StartDate
                      StartTime
                      StartCity
                      StartTerminal
                      EndDate
                      EndTime
                      EndCity
                      EndTerminal
                      FlightNumber
                      BookingClass {
                        ClassCode
                        ClassName
                        Cabin
                      }
                      NStopOvers
                      Equipment
                      BaggageAllowance
                      Distance
                      Duration
                      Status
                      VendorLocator
                      Seats {
                        TravellerNumber
                        SegmentNumber
                        SabreNameNumber
                        SeatData
                        Status
                      }
                      Requests {
                        TravellerNumber
                        SegmentNumber
                        SabreNameNumber
                        RequestType
                        RequestCode
                        RequestDetails
                      }
                    }
                  }
                  Traveller {
                    TravellerNumber
                    SabreNameNumber
                    Name {
                      Surname
                      Title
                      FirstName
                    }
                    TravellerReferences {
                      PaxProfileID
                    }
                    PaxType
                  }
                }
                EMDs {
                  EMDIssueDate
                  EMDIssueAgentID
                  EMDBranch
                  FirstEMDNumber
                  AccountingDataSummary {
                    IsExchange
                    UnableToRetrieve
                    TotalFareCharged
                    TotalTaxCharged
                  }
                  IATANumber
                  EMDType
                  EMDTypeCode
                  EMDDetails {
                    ReasonForIssueCode
                    ReasonForIssueSubCode
                    ServicePresentAt
                    ServicePresentTo
                    AssociatedTicketNumber
                    AssociatedRecordLocator
                  }
                }
                Requests {
                  RequestType
                  RequestCode
                  RequestDetails
                  TravellerNumber
                  SegmentNumber
                }
                Remarks {
                  RemarkType
                  RemarkQualifier
                  RemarkText
                }
              }
            }
          `,
          variables,
        });

        if (response.data.pnrs.length > 0) {
          this.item = response.data.pnrs[0];

          this.changeview("Travellers");
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    changeview(a) {
      console.log(a);
      this.active = a;
      this.items = [...this.item[this.active]];
      console.log(this.items);
      this.items.forEach(function (v) {
        delete v.__typename;
      });
    },
  },
};
</script>

<style>
</style>